import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <polygon points="12,18.831 0.459,7.29 1.873,5.876 12,16.003 22.127,5.876 23.541,7.29 " />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/ChevronDown.jsx